import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// Import Styled components
import {
  Wrapper,
  Content,
  GameDescription,
  LearnMore,
  Character
} from './GameDetailResponsive'

// Import common component
import Title from './Title'
import Description from './Description'

// Import themes modules
import { px2Rem } from '../../themes/Mixins'
import COLORS from '../../themes/Colors'

// Defined component GameDetail
const GameDetail = ({ matches, className, href, ...props }) => {
  const mobileDescription = props.description.length > 45 ?
    props.description.slice(0, 45) + '...'
    : props.description

    return (
    <a className={className} href={href}>
      <Wrapper bgColor='none'>
        <Content>
          <Title
            type='tiny'
            title={props.title}
          />
          <Description
            text={props.genre}
            type='xxxTiny'
          />
        </Content>
        {
          !matches && 
          <GameDescription
            text={props.description}
            type='xxTiny'
          />
        }
        <LearnMore>
          Learn More
          <Character>
            &rarr;
          </Character>
        </LearnMore>
      </Wrapper>
    </a>
  )
}

export default styled(GameDetail)`
  padding: ${px2Rem(40)} ${px2Rem(30)};
  background-color: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  display: block;
  text-decoration: none;

  @media(min-width: 768px) {
    background-color: ${COLORS.bgGameDetail};
    display: none;
  }
`

GameDetail.propTypes = {
  title: PropTypes.string,
  author: PropTypes.string,
  description: PropTypes.string
}

GameDetail.defaultProps = {
  title: '',
  author: '',
  description: ''
}



// WEBPACK FOOTER //
// ./src/components/common/GameDetail.js